'use strict';

Array.prototype.find || Object.defineProperty(Array.prototype, "find", { value: function (r) { if (null == this) throw TypeError('"this" is null or not defined'); var t = Object(this), e = t.length >>> 0; if ("function" != typeof r) throw TypeError("predicate must be a function"); for (var i = arguments[1], o = 0; o < e;) { var n = t[o]; if (r.call(i, n, o, t)) return n; o++ } }, configurable: !0, writable: !0 });

if (typeof TranslationLabCurrency === 'undefined') {
    var TranslationLabCurrency = {};
}

TranslationLabCurrency.cookie = {
    name: 'translation-lab-currency',
    write: function (currency) {
        localStorage.setItem(this.name, currency);
    },
    read: function () {
        return localStorage.getItem(this.name);
    },
    destroy: function () {
        localStorage.removeItem(this.name);
    }
};

TranslationLabCurrency.moneyFormats = {
    "USD": {
        "money_format": "${{amount_no_decimals}}",
        "money_with_currency_format": "${{amount_no_decimals}} USD"
    },
    "EUR": {
        "money_format": "{{amount}} &euro;",
        "money_with_currency_format": "&euro;{{amount}} EUR"
    },
    "GBP": {
        "money_format": "&pound;{{amount_no_decimals}}",
        "money_with_currency_format": "&pound;{{amount_no_decimals}} GBP"
    },
    "CAD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} CAD"
    },
    "ALL": {
        "money_format": "Lek {{amount}}",
        "money_with_currency_format": "Lek {{amount}} ALL"
    },
    "DZD": {
        "money_format": "DA {{amount}}",
        "money_with_currency_format": "DA {{amount}} DZD"
    },
    "AOA": {
        "money_format": "Kz{{amount}}",
        "money_with_currency_format": "Kz{{amount}} AOA"
    },
    "ARS": {
        "money_format": "${{amount_with_comma_separator}}",
        "money_with_currency_format": "${{amount_with_comma_separator}} ARS"
    },
    "AMD": {
        "money_format": "{{amount}} AMD",
        "money_with_currency_format": "{{amount}} AMD"
    },
    "AWG": {
        "money_format": "Afl{{amount}}",
        "money_with_currency_format": "Afl{{amount}} AWG"
    },
    "AUD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} AUD"
    },
    "BBD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} Bds"
    },
    "AZN": {
        "money_format": "m.{{amount}}",
        "money_with_currency_format": "m.{{amount}} AZN"
    },
    "BDT": {
        "money_format": "Tk {{amount}}",
        "money_with_currency_format": "Tk {{amount}} BDT"
    },
    "BSD": {
        "money_format": "BS${{amount}}",
        "money_with_currency_format": "BS${{amount}} BSD"
    },
    "BHD": {
        "money_format": "{{amount}}0 BD",
        "money_with_currency_format": "{{amount}}0 BHD"
    },
    "BYR": {
        "money_format": "Br {{amount}}",
        "money_with_currency_format": "Br {{amount}} BYR"
    },
    "BIF": {
        "money_format": "FBu {{amount}}",
        "money_with_currency_format": "FBu {{amount}} BIF"
    },
    "BZD": {
        "money_format": "BZ${{amount}}",
        "money_with_currency_format": "BZ${{amount}} BZD"
    },
    "BTN": {
        "money_format": "Nu {{amount}}",
        "money_with_currency_format": "Nu {{amount}} BTN"
    },
    "BAM": {
        "money_format": "KM {{amount_with_comma_separator}}",
        "money_with_currency_format": "KM {{amount_with_comma_separator}} BAM"
    },
    "BRL": {
        "money_format": "R$ {{amount_with_comma_separator}}",
        "money_with_currency_format": "R$ {{amount_with_comma_separator}} BRL"
    },
    "BOB": {
        "money_format": "Bs{{amount_with_comma_separator}}",
        "money_with_currency_format": "Bs{{amount_with_comma_separator}} BOB"
    },
    "BWP": {
        "money_format": "P{{amount}}",
        "money_with_currency_format": "P{{amount}} BWP"
    },
    "BND": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} BND"
    },
    "BGN": {
        "money_format": "{{amount}} лв",
        "money_with_currency_format": "{{amount}} лв BGN"
    },
    "MMK": {
        "money_format": "K{{amount}}",
        "money_with_currency_format": "K{{amount}} MMK"
    },
    "KHR": {
        "money_format": "KHR{{amount}}",
        "money_with_currency_format": "KHR{{amount}}"
    },
    "KYD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} KYD"
    },
    "XAF": {
        "money_format": "FCFA{{amount}}",
        "money_with_currency_format": "FCFA{{amount}} XAF"
    },
    "CLP": {
        "money_format": "${{amount_no_decimals}}",
        "money_with_currency_format": "${{amount_no_decimals}} CLP"
    },
    "CNY": {
        "money_format": "&#165;{{amount}}",
        "money_with_currency_format": "&#165;{{amount}} CNY"
    },
    "COP": {
        "money_format": "${{amount_with_comma_separator}}",
        "money_with_currency_format": "${{amount_with_comma_separator}} COP"
    },
    "CRC": {
        "money_format": "&#8353; {{amount_with_comma_separator}}",
        "money_with_currency_format": "&#8353; {{amount_with_comma_separator}} CRC"
    },
    "HRK": {
        "money_format": "{{amount_with_comma_separator}} kn",
        "money_with_currency_format": "{{amount_with_comma_separator}} kn HRK"
    },
    "CZK": {
        "money_format": "{{amount}} K&#269;",
        "money_with_currency_format": "{{amount}} K&#269;"
    },
    "DKK": {
        "money_format": "{{amount_with_comma_separator}}",
        "money_with_currency_format": "kr.{{amount_with_comma_separator}}"
    },
    "DOP": {
        "money_format": "RD$ {{amount}}",
        "money_with_currency_format": "RD$ {{amount}}"
    },
    "XCD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "EC${{amount}}"
    },
    "EGP": {
        "money_format": "LE {{amount}}",
        "money_with_currency_format": "LE {{amount}} EGP"
    },
    "ETB": {
        "money_format": "Br{{amount}}",
        "money_with_currency_format": "Br{{amount}} ETB"
    },
    "XPF": {
        "money_format": "{{amount_no_decimals_with_comma_separator}} XPF",
        "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} XPF"
    },
    "FJD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "FJ${{amount}}"
    },
    "GMD": {
        "money_format": "D {{amount}}",
        "money_with_currency_format": "D {{amount}} GMD"
    },
    "GHS": {
        "money_format": "GH&#8373;{{amount}}",
        "money_with_currency_format": "GH&#8373;{{amount}}"
    },
    "GTQ": {
        "money_format": "Q{{amount}}",
        "money_with_currency_format": "{{amount}} GTQ"
    },
    "GYD": {
        "money_format": "G${{amount}}",
        "money_with_currency_format": "${{amount}} GYD"
    },
    "GEL": {
        "money_format": "{{amount}} GEL",
        "money_with_currency_format": "{{amount}} GEL"
    },
    "HNL": {
        "money_format": "L {{amount}}",
        "money_with_currency_format": "L {{amount}} HNL"
    },
    "HKD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "HK${{amount}}"
    },
    "HUF": {
        "money_format": "{{amount_no_decimals_with_comma_separator}}",
        "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} Ft"
    },
    "ISK": {
        "money_format": "{{amount_no_decimals}} kr",
        "money_with_currency_format": "{{amount_no_decimals}} kr ISK"
    },
    "INR": {
        "money_format": "Rs. {{amount}}",
        "money_with_currency_format": "Rs. {{amount}}"
    },
    "IDR": {
        "money_format": "{{amount_with_comma_separator}}",
        "money_with_currency_format": "Rp {{amount_with_comma_separator}}"
    },
    "ILS": {
        "money_format": "{{amount}} NIS",
        "money_with_currency_format": "{{amount}} NIS"
    },
    "JMD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} JMD"
    },
    "JPY": {
        "money_format": "&#165;{{amount_no_decimals}}",
        "money_with_currency_format": "&#165;{{amount_no_decimals}} JPY"
    },
    "JEP": {
        "money_format": "&pound;{{amount}}",
        "money_with_currency_format": "&pound;{{amount}} JEP"
    },
    "JOD": {
        "money_format": "{{amount}}0 JD",
        "money_with_currency_format": "{{amount}}0 JOD"
    },
    "KZT": {
        "money_format": "{{amount}} KZT",
        "money_with_currency_format": "{{amount}} KZT"
    },
    "KES": {
        "money_format": "KSh{{amount}}",
        "money_with_currency_format": "KSh{{amount}}"
    },
    "KWD": {
        "money_format": "{{amount}}0 KD",
        "money_with_currency_format": "{{amount}}0 KWD"
    },
    "KGS": {
        "money_format": "лв{{amount}}",
        "money_with_currency_format": "лв{{amount}}"
    },
    "LVL": {
        "money_format": "Ls {{amount}}",
        "money_with_currency_format": "Ls {{amount}} LVL"
    },
    "LBP": {
        "money_format": "L&pound;{{amount}}",
        "money_with_currency_format": "L&pound;{{amount}} LBP"
    },
    "LTL": {
        "money_format": "{{amount}} Lt",
        "money_with_currency_format": "{{amount}} Lt"
    },
    "MGA": {
        "money_format": "Ar {{amount}}",
        "money_with_currency_format": "Ar {{amount}} MGA"
    },
    "MKD": {
        "money_format": "ден {{amount}}",
        "money_with_currency_format": "ден {{amount}} MKD"
    },
    "MOP": {
        "money_format": "MOP${{amount}}",
        "money_with_currency_format": "MOP${{amount}}"
    },
    "MVR": {
        "money_format": "Rf{{amount}}",
        "money_with_currency_format": "Rf{{amount}} MRf"
    },
    "MXN": {
        "money_format": "$ {{amount}}",
        "money_with_currency_format": "$ {{amount}} MXN"
    },
    "MYR": {
        "money_format": "RM{{amount}} MYR",
        "money_with_currency_format": "RM{{amount}} MYR"
    },
    "MUR": {
        "money_format": "Rs {{amount}}",
        "money_with_currency_format": "Rs {{amount}} MUR"
    },
    "MDL": {
        "money_format": "{{amount}} MDL",
        "money_with_currency_format": "{{amount}} MDL"
    },
    "MAD": {
        "money_format": "{{amount}} dh",
        "money_with_currency_format": "Dh {{amount}} MAD"
    },
    "MNT": {
        "money_format": "{{amount_no_decimals}} &#8366",
        "money_with_currency_format": "{{amount_no_decimals}} MNT"
    },
    "MZN": {
        "money_format": "{{amount}} Mt",
        "money_with_currency_format": "Mt {{amount}} MZN"
    },
    "NAD": {
        "money_format": "N${{amount}}",
        "money_with_currency_format": "N${{amount}} NAD"
    },
    "NPR": {
        "money_format": "Rs{{amount}}",
        "money_with_currency_format": "Rs{{amount}} NPR"
    },
    "ANG": {
        "money_format": "&fnof;{{amount}}",
        "money_with_currency_format": "{{amount}} NA&fnof;"
    },
    "NZD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} NZD"
    },
    "NIO": {
        "money_format": "C${{amount}}",
        "money_with_currency_format": "C${{amount}} NIO"
    },
    "NGN": {
        "money_format": "&#8358;{{amount}}",
        "money_with_currency_format": "&#8358;{{amount}} NGN"
    },
    "NOK": {
        "money_format": "kr {{amount_with_comma_separator}}",
        "money_with_currency_format": "kr {{amount_with_comma_separator}} NOK"
    },
    "OMR": {
        "money_format": "{{amount_with_comma_separator}} OMR",
        "money_with_currency_format": "{{amount_with_comma_separator}} OMR"
    },
    "PKR": {
        "money_format": "Rs.{{amount}}",
        "money_with_currency_format": "Rs.{{amount}} PKR"
    },
    "PGK": {
        "money_format": "K {{amount}}",
        "money_with_currency_format": "K {{amount}} PGK"
    },
    "PYG": {
        "money_format": "Gs. {{amount_no_decimals_with_comma_separator}}",
        "money_with_currency_format": "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
    },
    "PEN": {
        "money_format": "S/. {{amount}}",
        "money_with_currency_format": "S/. {{amount}} PEN"
    },
    "PHP": {
        "money_format": "&#8369;{{amount}}",
        "money_with_currency_format": "&#8369;{{amount}} PHP"
    },
    "PLN": {
        "money_format": "{{amount_with_comma_separator}} zl",
        "money_with_currency_format": "{{amount_with_comma_separator}} zl PLN"
    },
    "QAR": {
        "money_format": "QAR {{amount_with_comma_separator}}",
        "money_with_currency_format": "QAR {{amount_with_comma_separator}}"
    },
    "RON": {
        "money_format": "{{amount_with_comma_separator}} lei",
        "money_with_currency_format": "{{amount_with_comma_separator}} lei RON"
    },
    "RUB": {
        "money_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
        "money_with_currency_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
    },
    "RWF": {
        "money_format": "{{amount_no_decimals}} RF",
        "money_with_currency_format": "{{amount_no_decimals}} RWF"
    },
    "WST": {
        "money_format": "WS$ {{amount}}",
        "money_with_currency_format": "WS$ {{amount}} WST"
    },
    "SAR": {
        "money_format": "{{amount}} SR",
        "money_with_currency_format": "{{amount}} SAR"
    },
    "STD": {
        "money_format": "Db {{amount}}",
        "money_with_currency_format": "Db {{amount}} STD"
    },
    "RSD": {
        "money_format": "{{amount}} RSD",
        "money_with_currency_format": "{{amount}} RSD"
    },
    "SCR": {
        "money_format": "Rs {{amount}}",
        "money_with_currency_format": "Rs {{amount}} SCR"
    },
    "SGD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} SGD"
    },
    "SYP": {
        "money_format": "S&pound;{{amount}}",
        "money_with_currency_format": "S&pound;{{amount}} SYP"
    },
    "ZAR": {
        "money_format": "R {{amount}}",
        "money_with_currency_format": "R {{amount}} ZAR"
    },
    "KRW": {
        "money_format": "&#8361;{{amount_no_decimals}}",
        "money_with_currency_format": "&#8361;{{amount_no_decimals}} KRW"
    },
    "LKR": {
        "money_format": "Rs {{amount}}",
        "money_with_currency_format": "Rs {{amount}} LKR"
    },
    "SEK": {
        "money_format": "{{amount_no_decimals}} kr",
        "money_with_currency_format": "{{amount_no_decimals}} kr SEK"
    },
    "CHF": {
        "money_format": "SFr. {{amount}}",
        "money_with_currency_format": "SFr. {{amount}} CHF"
    },
    "TWD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} TWD"
    },
    "THB": {
        "money_format": "{{amount}} &#xe3f;",
        "money_with_currency_format": "{{amount}} &#xe3f; THB"
    },
    "TZS": {
        "money_format": "{{amount}} TZS",
        "money_with_currency_format": "{{amount}} TZS"
    },
    "TTD": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}} TTD"
    },
    "TND": {
        "money_format": "{{amount}}",
        "money_with_currency_format": "{{amount}} DT"
    },
    "TRY": {
        "money_format": "{{amount}}TL",
        "money_with_currency_format": "{{amount}}TL"
    },
    "UGX": {
        "money_format": "Ush {{amount_no_decimals}}",
        "money_with_currency_format": "Ush {{amount_no_decimals}} UGX"
    },
    "UAH": {
        "money_format": "₴{{amount}}",
        "money_with_currency_format": "₴{{amount}} UAH"
    },
    "AED": {
        "money_format": "Dhs. {{amount}}",
        "money_with_currency_format": "Dhs. {{amount}} AED"
    },
    "UYU": {
        "money_format": "${{amount_with_comma_separator}}",
        "money_with_currency_format": "${{amount_with_comma_separator}} UYU"
    },
    "VUV": {
        "money_format": "${{amount}}",
        "money_with_currency_format": "${{amount}}VT"
    },
    "VEF": {
        "money_format": "Bs. {{amount_with_comma_separator}}",
        "money_with_currency_format": "Bs. {{amount_with_comma_separator}} VEF"
    },
    "VND": {
        "money_format": "{{amount_no_decimals_with_comma_separator}}&#8363;",
        "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} VND"
    },
    "XBT": {
        "money_format": "{{amount_no_decimals}} BTC",
        "money_with_currency_format": "{{amount_no_decimals}} BTC"
    },
    "XOF": {
        "money_format": "CFA{{amount}}",
        "money_with_currency_format": "CFA{{amount}} XOF"
    },
    "ZMW": {
        "money_format": "K{{amount_no_decimals_with_comma_separator}}",
        "money_with_currency_format": "ZMW{{amount_no_decimals_with_comma_separator}}"
    }
};

TranslationLabCurrency.formatMoney = function (cents, format) {
    if (typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, format);
    }
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';
    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ' ');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) { return 0; }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};

TranslationLabCurrency.currentCurrency = '';

TranslationLabCurrency.format = 'money_format';

TranslationLabCurrency.convertAll = function (baseCurrency, oldCurrency, newCurrency, selector, format) {

    if (!newCurrency) return;

    function getAmount(el, baseFormat) {
        var htmlContent = el.innerText;
        if (baseFormat.indexOf('amount_no_decimals') !== -1) {
            return parseInt(htmlContent.replace(/[^0-9]/g, ''), 10) * 100;
        }
        if (baseCurrency === 'JOD' || baseCurrency === 'KWD' || baseCurrency === 'BHD') {
            return parseInt(htmlContent.replace(/[^0-9]/g, ''), 10) / 10;
        }
        return parseInt(htmlContent.replace(/[^0-9]/g, ''), 10);
    }

    document.querySelectorAll(selector || 'span.money').forEach(function (el) {

        var baseFormat = TranslationLabCurrency.moneyFormats[baseCurrency];
        var newFormat = TranslationLabCurrency.moneyFormats[newCurrency];

        if (baseFormat)
            baseFormat = baseFormat[format || TranslationLabCurrency.format] || '{{amount}}';
        else
            baseFormat = '{{amount}} ' + baseCurrency;

        if (newFormat)
            newFormat = newFormat[format || TranslationLabCurrency.format] || '{{amount}}';
        else
            newFormat = '{{amount}} ' + newCurrency;

        if (TranslationLabCurrency.themeMoneyFormat.indexOf('amount_no_decimals') > -1) {
          baseFormat = baseFormat.replace(/{{(([^}][^}]?|[^}]}?)*)}}/, '{{amount_no_decimals}}');
          newFormat = newFormat.replace(/{{(([^}][^}]?|[^}]}?)*)}}/, '{{amount_no_decimals}}');
        }

        var currentAmount = getAmount(el, baseFormat);

        if (isNaN(currentAmount)) {
            return;
        }

        if (!el.getAttribute('data-base-currency')) {
            el.setAttribute('data-base-currency', baseCurrency);
            el.setAttribute('data-base-amount', currentAmount);
        } else {
            currentAmount = el.getAttribute('data-base-amount');
        }

        if (el.getAttribute('data-currency') === newCurrency) return;
        if (el.getAttribute('data-currency-' + newCurrency)) {
            el.innerHTML = el.getAttribute('data-currency-' + newCurrency);
        }
        else {
            var cents = Currency.convert(currentAmount, baseCurrency, newCurrency);
            var newFormattedAmount = TranslationLabCurrency.formatMoney(cents, newFormat);
            el.innerHTML = newFormattedAmount;
            el.setAttribute('data-currency-' + newCurrency, newFormattedAmount);
        }
        el.setAttribute('data-currency', newCurrency);
    });
    this.currentCurrency = newCurrency;
    this.cookie.write(newCurrency);
};


function redirectHandlerFactory(redirectConfig) {
    var shopDomain = redirectConfig.shopDomain;
    var currentLocale = redirectConfig.currentLocale.toLowerCase();
    var currentLocaleRegEx = new RegExp('^\/' + currentLocale, 'ig');
    var primaryLocaleLower = redirectConfig.primaryLocale.toLowerCase();

    function removeLocaleFromPath(pathname, languageList) {
        var pathParts = pathname.split('/');
        var idx = -1;
        for (var i = 0; i < languageList.length; i++) {
            var localeIdx = pathParts.indexOf(languageList[i].iso_code);
            if (localeIdx === 1) {
                idx = localeIdx;
                break;
            }
        }
        if (idx === 1) {
            pathParts.splice(idx, 1);
            return pathParts.join('/');
        }
        return pathname;
    }

    function buildRedirectUrl(redirectLocale) {
        if (!redirectLocale) return null;

        var redirectLocaleLower = redirectLocale.toLowerCase();
        if (currentLocale === redirectLocaleLower) return null;

        var pathname = window.location.pathname;
        var queryString = window.location.search || '';

        if (redirectConfig.useInternationalDomains) {
            var internationalDomain = redirectConfig.languageList.find(function (x) { return x.iso_code.toLowerCase() === redirectLocaleLower; });
            if (internationalDomain) {
                var path = removeLocaleFromPath(pathname, redirectConfig.languageList);
                return 'https://' + internationalDomain.domain + path + queryString;
            }
            return null;
        }

        if (redirectLocaleLower === primaryLocaleLower) return shopDomain + pathname.replace(currentLocaleRegEx, '') + queryString;
        if (primaryLocaleLower === currentLocale) return shopDomain + '/' + redirectLocaleLower + pathname + queryString;
        return shopDomain + '/' + pathname.replace(currentLocaleRegEx, redirectLocaleLower) + queryString;
    }

    return {
        redirectToLocale: function (newLocale) {
            var redirectUrl = buildRedirectUrl(newLocale);
            redirectUrl && window.location.assign(redirectUrl);
        }
    };
}

function dropdownHandler(dropdownConfig) {

    var isOpen = false;

    var container = document.getElementById(dropdownConfig.languageSwitcherId);
    var dropdown = container.children[0];
    var ul = container.getElementsByTagName('ul')[0];
    var span = dropdown.getElementsByTagName('span')[0];
    var selectedImg = dropdown.getElementsByTagName('img')[0];

    function open() {
        isOpen = true;
        dropdown.classList.add('open');
        ul.classList.add('open');
    }

    function close() {
        isOpen = false;
        dropdown.classList.remove('open');
        ul.classList.remove('open');
    }

    function selectLanguage(languageCode) {

        close();

        if (!languageCode) return;

        var selectedLanguage = dropdownConfig.languageList.find(function (language) {
            return language.iso_code.toLowerCase() === languageCode.toLowerCase();
        });

        if (!selectedLanguage) return;

        if (dropdownConfig.labelType === 'language-name')
            span.textContent = selectedLanguage.endonym_name;
        else
            span.textContent = selectedLanguage.iso_code;

        if (selectedImg)
            selectedImg.src = selectedLanguage.flag;

        if (dropdownConfig.onItemSelect) dropdownConfig.onItemSelect(selectedLanguage);
    }

    dropdown.addEventListener('click', function (event) {
        event.preventDefault();
        if (isOpen)
            close();
        else
            open();
    });

    //container.addEventListener('mouseleave', close);

    if (ul && ul.children) {
        Array.prototype.forEach.call(ul.children, function (li) {
            var languageCode = li.dataset.languageCode;
            li.addEventListener('click', function () { selectLanguage(languageCode); });
        });
    }

    return {
        selectLanguage: selectLanguage,
        openDropdown: open,
        closeDropdown: close
    };
}

function currencySwitcherHandler(config, callback) {

    var currentLanguage = config.languageList.find(function (language) {
        return language.iso_code.toLowerCase() === config.currentLocale.toLowerCase();
    });
    var langCurrencies = config.langCurrencies;
    var currencySwitcherId = config.currencySwitcherId;
    var currencyOptionsId = config.currencyOptionsId;
    var savedCurrencyCode = TranslationLabCurrency.cookie.read();
    var currencyForCurrentLanguage = findCurrencyForLanguage(currentLanguage.iso_code, savedCurrencyCode);
    var currentCurrencyCode = currencyForCurrentLanguage ? currencyForCurrentLanguage.code : config.shopCurrencyCode;

    var isOpen = false;

    var container = document.getElementById(currencySwitcherId);
    var dropdown = container.children[0];
    var ul = container.getElementsByTagName('ul')[0];

    function open() {
        isOpen = true;
        dropdown.classList.add('open');
        ul.classList.add('open');
    }

    function close() {
        isOpen = false;
        dropdown.classList.remove('open');
        ul.classList.remove('open');
    }

    function convertAll(languageCode, targetCurrencyCode) {

        if (!languageCode) return null;

        var targetCurrency = findCurrencyForLanguage(languageCode, targetCurrencyCode);

        if (!targetCurrency) return null;

        TranslationLabCurrency.convertAll(config.shopCurrencyCode, currentCurrencyCode, targetCurrency.code, config.currencyFormatClass);

        currentCurrencyCode = targetCurrency.code;

        return targetCurrency.code;
    }

    function selectCurrency(lang, currency) {

        close();

        if (!currency) return;

        document.querySelectorAll('.tl-dropdown.currency-selection').forEach(function (el) {
            var sp = el.getElementsByTagName('span')[0];
            var img = el.getElementsByTagName('img')[0];
            sp.innerText = currency.code;
            if (img) img.src = config.imgFileTemplate.replace('ccode', currency.code);
        });

        if (config.switcherMode === 'currency_switcher') {
            convertAll(lang.iso_code, currency.code);
        } else {
            if (callback) callback(currency);
        }
    }

    function updateCurrencyList(lang, selectedCurrencyCode) {

        var langCodePart = lang.iso_code.split('-')[0];
        var langCurrencyMapping = langCurrencies.find(function (x) { return x.languageCode === lang.iso_code || x.languageCode === langCodePart; });

        if (!langCurrencyMapping || !langCurrencyMapping.currencies) return;

        var currency = findCurrencyForLanguage(lang.iso_code, selectedCurrencyCode);

        if (!currency)
            currency = langCurrencyMapping[0];

        selectCurrency(lang, currency);

        var currencyOptionsElement = document.getElementById(currencyOptionsId);

        if (!currencyOptionsElement) return;

        currencyOptionsElement.innerHTML = '';

        langCurrencyMapping.currencies.forEach(function (currency1) {

            var li = document.createElement('li');

            li.classList.add('tl-option');

            if (config.showFlags) {
                var flagImg = document.createElement('img');
                var imgFile = config.imgFileTemplate.replace('ccode', currency1.code);
                flagImg.src = imgFile;
                flagImg.classList.add('tl-currency-flag');
                li.appendChild(flagImg);
            }

            var s1 = document.createElement('span');
            s1.classList.add('currency-label');
            s1.innerText = currency1.code;

            li.appendChild(s1);

            li.addEventListener('click', function () {
                selectCurrency(lang, currency1);
            });

            currencyOptionsElement.appendChild(li);
        });
    }

    function findCurrencyForLanguage(languageCode, currencyCode) {
        var langCodePart = languageCode.split('-')[0];
        var langCurrencyMapping = langCurrencies.find(function (x) { return x.languageCode === languageCode || x.languageCode === langCodePart; });
        if (!langCurrencyMapping || !langCurrencyMapping.currencies) return null;
        var currency = langCurrencyMapping.currencies.find(function (x) { return x.code === currencyCode; });
        if (!currency) return langCurrencyMapping.currencies[0];
        return currency;
    }

    function getCurrentCurrencyCode() {
        return currentCurrencyCode;
    }

    function updateAll() {
        var savedCurrency = TranslationLabCurrency.cookie.read();
        if (savedCurrency)
            convertAll(currentLanguage.iso_code, savedCurrency);
    }

    dropdown.addEventListener('click', function (event) {
        event.preventDefault();
        if (isOpen)
            close();
        else
            open();
    });

    //container.addEventListener('mouseleave', close);

    var savedCurrency = TranslationLabCurrency.cookie.read();
    var currency = savedCurrency ? savedCurrency : config.shopCurrencyCode;
    updateCurrencyList(currentLanguage, currency);

    document.addEventListener('readystatechange', function (event) {
        document.querySelectorAll('select').forEach(function (element) {
            element.addEventListener('change', function (event) {
                updateAll();
                setTimeout(updateAll);
            });
        });
    });

    updateAll();


    const targetNode = document.querySelector('body');
    const observerConfig = { attributes: true, childList: true, subtree: true };

    const observerCallback = function (mutationsList, observer) {
        updateAll();
    };

    const observer = new MutationObserver(observerCallback);
    observer.observe(targetNode, observerConfig);

    return {
        getCurrentCurrencyCode: getCurrentCurrencyCode,
        updateCurrencyList: updateCurrencyList,
        selectCurrency: selectCurrency,
        convertAll: convertAll,
        openDropdown: open,
        closeDropdown: close
    };
}

function tlabSwitcherFactory(config) {

    var primaryLanguage = config.languageList.find(function (x) { return x.primary; });

    var redirectHandler = redirectHandlerFactory({
        shopDomain: config.shopDomain,
        useInternationalDomains: config.useInternationalDomains,
        primaryLocale: primaryLanguage.iso_code,
        currentLocale: config.currentLocale,
        languageList: config.languageList
    });

    var currencyToChange = null;
    var languageCodeToChange = null;

    var isMainDropdownOpen = false;
    var popupId = config.popupId;

    function open() {
        var popupElement = document.getElementById(popupId);

        if (popupElement)
            popupElement.classList.add('active');

        isMainDropdownOpen = true;
    }

    function close() {
        var popupElement = document.getElementById(popupId);

        if (popupElement != null)
            popupElement.classList.remove('active');

        isMainDropdownOpen = false;
    }

    function save(currencySwitcherHandler) {

        if (currencyToChange) {
            var currencyLanguage = languageCodeToChange;
            if (!currencyLanguage) currencyLanguage = config.currentLocale;
            var targetCurrencyCode = currencySwitcherHandler.convertAll(currencyLanguage, currencyToChange);
            if (targetCurrencyCode) {
                updateCurrencySelection(targetCurrencyCode);
            }
            currencyToChange = null;
        }

        if (languageCodeToChange) {
            localStorage.setItem('translation-lab-lang', languageCodeToChange);
            redirectHandler.redirectToLocale(languageCodeToChange);
        }

        close();
    }

    function updateCurrencySelection(currencyCode) {
        document.querySelectorAll('.selected-currency').forEach(function (el) {
            var sp = el.getElementsByTagName('span')[0];
            var img = el.getElementsByTagName('img')[0];
            sp.innerText = currencyCode;
            if (img) img.src = config.imgFileTemplate.replace('ccode', currencyCode);
        });
    }

    function onOutsideClick(callback) {
        var currencyWrapperClass = 'tl-wrapper';
        document.addEventListener('click', function (event) {
            if (!isMainDropdownOpen) return;
            if (event.target.className && typeof event.target.className == 'string' && event.target.className.includes(currencyWrapperClass)) return;
            for (var i = 0; i < event.path.length; i++) {
                if (event.path[i].className && typeof event.path[i].className == 'string' && event.path[i].className.includes(currencyWrapperClass)) return;
                if (event.path[i].className && typeof event.path[i].className == 'string' && event.path[i].className.includes('tl-switcher')) return;
            }
            callback();
        });
    }

    function configurePopupOverlay() {
        var popupElement = document.getElementById(popupId);
        if (popupElement) {
            popupElement.remove();
            document.body.appendChild(popupElement);
        }
    }


    function configureLanguageSwitcher() {

        var dropdownConfig = {
            languageSwitcherId: config.languageSwitcherId,
            languageList: config.languageList,
            labelType: config.labelType,
            onItemSelect: function (selectedLanguage) {
                if (selectedLanguage) {
                    localStorage.setItem('translation-lab-lang', selectedLanguage.iso_code);
                    redirectHandler.redirectToLocale(selectedLanguage.iso_code);
                }
            }
        };

        var dropdown = dropdownHandler(dropdownConfig);
    }

    function configureCurrencySwitcher() {
        var currencySwitcher = currencySwitcherHandler(config);
    }

    function configureLanguageAndCurrencySwitcher() {

        var currencySwitcher = currencySwitcherHandler(config, function (selectedCurrency) {
            currencyToChange = selectedCurrency.code;
        });
        updateCurrencySelection(currencySwitcher.getCurrentCurrencyCode());

        var dropdownConfig = {
            languageSwitcherId: config.languageSwitcherId,
            languageList: config.languageList,
            labelType: config.labelType,
            onItemSelect: function (selectedLanguage) {
                if (selectedLanguage) {
                    languageCodeToChange = selectedLanguage.iso_code;
                    var savedCurrency = TranslationLabCurrency.cookie.read();
                    var currency = savedCurrency ? savedCurrency : config.shopCurrencyCode;
                    currencySwitcher.updateCurrencyList(selectedLanguage, currency);
                }
            }
        };

        var dropdown = dropdownHandler(dropdownConfig);


        var currentSelectionsElement = document.getElementById(config.currentSelectionsId);
        if (currentSelectionsElement) {

            currentSelectionsElement.addEventListener('click', function (event) {
                event.preventDefault();
                if (isMainDropdownOpen) {
                    close();
                    currencySwitcher.closeDropdown();
                    dropdown.closeDropdown();
                }
                else {
                    open();
                }
            });
        }


        if (config.isModal) {
            configurePopupOverlay();
        }
        else {
            onOutsideClick(function () {
                close();
                dropdown.selectLanguage(config.currentLocale);
            });
        }


        var closeButtons = document.querySelectorAll('.modal-close-btn');
        closeButtons.forEach(function (el) {
            el.addEventListener('click', function () { close(); });
        });

        var saveButton = document.getElementById(config.submitButtonId);
        if (saveButton) {
            saveButton.addEventListener('click', function () { save(currencySwitcher) });
        }
    }


    switch (config.switcherMode) {
        case 'language_switcher':
            configureLanguageSwitcher();
            break;

        case 'currency_switcher':
            configureCurrencySwitcher();
            break;

        case 'language_and_currency_switcher':
            configureLanguageAndCurrencySwitcher();
            break;
    }

    return {
        openMainDropdown: open,
        closeMainDropdown: close,
        save: save
    };
}